module.exports = __webpack_public_path__ + "fonts/TT_Commons_Pro_600_DemiBold.fb5ab21.woff2";